import { Nullable } from "@mapmycustomers/shared";
import CountryCode from "@mapmycustomers/shared/enum/CountryCode";
import Address from "@mapmycustomers/shared/types/Address";
import GeoAddress from "@mapmycustomers/shared/types/GeoAddress";
import { isEmptyString } from "@mapmycustomers/shared/util/stringUtils";

const nullIfEmpty = (value: null | string | undefined): null | string => {
  return isEmptyString(value) ? null : (value as string);
};

const geoAddressToNullableAddress = (
  {
    address,
    city,
    country,
    countryCode,
    fullPostalCode,
    postalCode,
    region,
    regionCode,
  }: GeoAddress,
  wasAddressChanged: boolean
): Nullable<Address> => ({
  address: nullIfEmpty(address),
  city: nullIfEmpty(city),
  country: nullIfEmpty(country),
  countryCode: nullIfEmpty(countryCode as string) as CountryCode,
  postalCode: (wasAddressChanged ? undefined : fullPostalCode) ?? nullIfEmpty(postalCode),
  region: nullIfEmpty(region),
  regionCode: nullIfEmpty(regionCode),
});

export default geoAddressToNullableAddress;
